<template>

<div class="main email">

	<div class="promotions-heading">
		<h1><router-link to="/promotionpacks">Promotion Packs</router-link><i class="fas fa-chevron-right"></i><router-link :to="'/promotionpacks/' + push_pack_id" tag="a" class="breadcrumb">{{ push_pack_name }}</router-link><i v-if="push_pack_name" class="fas fa-chevron-right"></i>Email</h1>
	</div>

	<div class="filters with-save" style="border-bottom: 0 none;">
		<div></div>
		<div style="text-align: right;">{{ saveMessage }}</div>
		<div>
			<span :class="['button', saving || savingNewMarquee ? 'disabled' : 'promotions']" style="float: right; margin: -0.5em 0 0 0;" @click="saveEmail()">Save Email</span>
		</div>
	</div>

	<div class="two-columns">
		<div>
			<label>Subject</label>
			<input type="text" v-model="email.subject" class="promotions">

			<label>Heading</label>
			<input type="text" v-model="email.title" class="promotions">

			<label>Add an email banner</label>
			<div style="display: grid; grid-template-columns: 3fr 1fr 1fr; grid-gap: 1em; margin: 0 0 0.25em 0;">
				<div class="input-with-control">
					<input type="text" class="promotions" style="font-size: 0.9em;" placeholder="Search email banners" v-model="search_text" @keyup.enter="searchBanners()">
					<div class="button promotions input-go" @click="searchBanners()"><i class="fas fa-search"></i></div>
				</div>
				<div :class="['button', browseLoading ? 'disabled' : 'promotions']" style="height: 2em; padding: 0.5em;" @click="searchBanners('all')">{{ browseLoading ? "Loading..." : "Browse" }}</div>
				<div v-if="!showDropzone" class="button promotions" style="height: 2em; padding: 0.5em;" @click="showDropzone = !showDropzone">New</div>
				<div v-if="showDropzone && !savingNewMarquee" class="button cancel" style="height: 2em; padding: 0.5em;" @click="showDropzone = !showDropzone">Cancel</div>
				<div v-if="showDropzone && savingNewMarquee" class="button cancel" style="height: 2em; padding: 0.5em;"><i class="fas fa-spinner fa-spin"></i></div>
			</div>

			<div v-if="showDropzone" class="dropzone-wrapper">
				<vue-dropzone ref="event_poster_image_dropzone" id="event_poster_image_dropzone" :options="dropzoneOptions" @vdropzone-success="imageUploadSuccess"></vue-dropzone>
			</div>

			<label>Subhead</label>
			<input type="text" v-model="email.subhead" class="promotions"></input>
			<label>Content</label>
            <TiptapEditor :modelValue="email.content" @update="updateEmailContent" :key="emailContentHash" />

			<!-- <label>Highlight color</label>
			<input type="color" v-model="highlight_color" style="margin: 0 0 0 1em;"> -->

			<div v-if="message" class="empty-list">
				{{ message }}
				<div v-if="loading" class="loading"><i class="fas fa-spinner fa-spin"></i></div>
			</div>

		</div>

		<div class="email-section" style="margin: 1em; padding: 1em; border: 1px solid #ccc;">
			<h3>{{ email.title }}</h3>
			<img :src="email.image_src" class="email-banner" style="max-width: 100%;">
			<h4 v-html="email.subhead"></h4>
			<div v-html="email.content"></div>

			<!-- <div class="email-product-grid">
				<div v-for="(product, index) in products" :key="index" class="email-product">
					<div class="display-flag" :style="'background-color: ' + displayFlags[product.display_flag]['color']">{{ displayFlags[product.display_flag]['label'] }}</div>
					<div style="text-align: center;">
						<img :src="product.image_src" class="email-product-image">
					</div>
					<div class="description">{{ product.description }}</div>
					<div class="price-row">
						<div class="meta">
							ID: {{ product.product_id }}<br>
							UPC: {{ product.upc }}
						</div>
						<div class="price">${{ product.customer_price }}</div>
					</div>
					<div class="button-row">
						<div class="fake-button" style="background-color: #999;">Details</div>
						<div class="fake-button" :style="'background-color: ' + email.highlight_color + ';'">Buy Now</div>
					</div>
				</div>
			</div> -->

            <div class="email-product-grid-note">
                NOTE: the Email Blast will include products associated with this Promo Pack.
            </div>

		</div>

	</div>

	<div v-if="showModal" class="modal">
		<div class="inner">
			<h2>Email Banner Search Results</h2>
			<div class="content">
				<div v-if="modalList.length < 1" class="empty-list">
					No email banners found {{ search_text ? "for '" + search_text + "'" : "" }}
				</div>
				<div v-else class="marquee-search-list">
					<div v-for="(marquee, index) in modalList" :key="index" @click="assingMarquee(marquee)">
						<img :src="marquee.image_src">
						<span class="caption">{{ marquee.description }}</span>
					</div>
				</div>
			</div>
			<div class="modal-controls">
				<div class="button cancel" @click="showModal = false">Cancel</div>
			</div>
		</div>
	</div>

</div>
</template>

<script>
import TiptapEditor from '@/components/TiptapEditor.vue'
export default {
	name: 'email',
	props: ['push_pack_id'],
    components: {
        TiptapEditor
    },
	data() {
		return {
			loading: true,
			message: 'Loading',
            editor: null,
            editorContent: '',
			push_pack_name: '',
			highlight_color: '#000000',
			email: {
				marquee_id: '',
				image_src: '',
				content: ''
			},
			emailContentHash: '',
			products: [],
			productsMessage: '',
			dropzoneOptions: {
				url: 'https://' + (document.location.hostname.indexOf('localhost') > -1 ? 'navigator.test' : document.location.hostname + '/api') + '/api.php?action=upload_image',
				thumbnailWidth: 420,
				thumbnailHeight: 140,
				maxFiles: 1,
				addRemoveLinks: true,
				acceptedFiles: 'image/*',
				dictDefaultMessage: 'Drag or click to add a new image.<br>(Recommended 1800 x 600 jpg)',
				withCredentials: true,
				headers: {
					'Cache-Control': null,
					'X-Requested-With': null
				}
			},
			showDropzone: false,
			savingNewMarquee: false,
			newFileName: '',
			search_text: '',
			showModal: false,
			browseLoading: false,
			saving: false,
			saveMessage: '',
			// displayFlags: {
    		// 	0: {'label': '', 'color': "#fff;"},
    		// 	1: {'label': 'Sale', 'color': "#C71D22;"},
    		// 	2: {'label': 'Temporary Price Reduction', 'color': "#F8B100;"},
    		// 	3: {'label': 'Temporary Lower Cost', 'color': "#00CE22;"},
    		// 	4: {'label': 'Free Shipping', 'color': "#0061E0;"},
    		// 	5: {'label': 'Shop In-Store For Lowest Prices', 'color': "#DF8605;"},
    		// 	6: {'label': 'Closeout', 'color': "#27C344;"}
    		// }
		}
	},
	created() {
		this.getItem()
		//this.getProducts()
	},
	methods: {
		getItem() {
			this.email = {
				marquee_id: '',
				image_src: '',
				content: ''
			}
            this.loading = true
            this.message = 'Loading'
            this.apiCall({ destination: 'get_item_push_pack_email', data: { push_pack_id: this.push_pack_id } }).then(obj => {
                this.loading = false
                this.message = obj.message
                if (obj.status == 'success') {
					this.push_pack_name = obj.push_pack_name
					if (obj.email.push_pack_id) {
						this.email = obj.email
						this.emailContentHash = this.email.content.length
					}
					this.email.push_pack_id = this.push_pack_id
					if (this.email.image_src) {
						this.image_src = this.email.image_src
					}
					if (this.email.highlight_color) {
						this.highlight_color = this.email.highlight_color
					}
                }
            })
		},
        updateEmailContent(content) {
			this.email.content = content
		},
		// getProducts() {
		// 	this.apiCall({ destination: 'get_list_push_pack_products', data: { push_pack_id: this.push_pack_id } }).then(obj => {
		// 		this.message = obj.message
		// 		if (obj.status == 'success') {
		// 			this.products = obj.products
		// 			if (this.products.length < 1) {
		// 				this.productsMessage = 'No products set for this promotion pack'
		// 			}
		// 		}
		// 	})
		// },
		searchBanners(searchScope) {
			if (searchScope != 'all' && !this.search_text) { return }
			if (searchScope == 'all') {
				this.search_text = ''
				this.browseLoading = true
			}
			this.apiCall({ destination: 'get_list_email_marquees', data: { search_text: this.search_text } }).then(obj => {
				this.showModal = true
				this.modalMessage = obj.message
				this.modalList = obj.marquees
				this.browseLoading = false
			})
		},
		assingMarquee(marquee) {
			this.email.marquee_id = marquee.marquee_id
			this.email.image_src = marquee.image_src
			this.showModal = false
			this.modalMessage = ''
			this.modalList = []
		},
		imageUploadSuccess(file, response) {
			let obj = JSON.parse(response)
			this.uploadMessage = obj.message
			if (obj.status == 'success') {
				this.newFileName = obj.file_name
				this.saveNewMarquee(obj.file_name)
			}
		},
		saveNewMarquee(fileName) {
			if (this.savingNewMarquee) { return }
			this.savingNewMarquee = true
			this.apiCall({ destination: 'save_new_marquee', data: { push_pack_id: this.push_pack_id, file_name: fileName, context: 'EMAIL_BANNER' } }).then(obj => {
				this.message = obj.message
				this.savingNewMarquee = false
				if (obj.status == 'success') {
					this.email.image_src = obj.marquee.image_src
					this.showDropzone = false
				} else {
					this.uploadMessage = obj.message
				}
			})
		},
		saveEmail() {
			if (this.saving || this.savingNewMarquee) { return }
			this.saving = true
			//this.email.image_src = this.image_src
			this.email.highlight_color = this.highlight_color
			this.apiCall({ destination: 'save_item_push_pack_email', data: this.email }).then(obj => {
				this.saving = false
				this.saveMessage = obj.message
				setTimeout(() => { this.saveMessage = '' }, 3000)
			})
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
